import { Injectable } from '@angular/core';
import { ICardItem } from '@core/interfaces/card/card-item-interface';
import { ICardSource } from '@core/interfaces/card/card-source.interface';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { CARD_LIST } from '@core/mocks/card/card.mock';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { CardCartItem } from '../../models/card/card-cart-item.model';

@Injectable()
export class CardSourceMockService implements ICardSource {

  getList(): Observable<IListResult<ICardItem>> {
    return of(CARD_LIST).pipe(delay(750));
  }

  addToCart(item: CardCartItem): Observable<Response> {
    return of(new Response()).pipe(delay(750));
  }

}
